var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00033 0.666504C13.6028 0.666504 17.3337 4.39734 17.3337 8.99984C17.3337 13.6023 13.6028 17.3332 9.00033 17.3332C4.39783 17.3332 0.666992 13.6023 0.666992 8.99984C0.666992 4.39734 4.39783 0.666504 9.00033 0.666504ZM9.00033 3.99984C8.77931 3.99984 8.56735 4.08763 8.41107 4.24392C8.25479 4.4002 8.16699 4.61216 8.16699 4.83317V8.99984C8.16704 9.22083 8.25487 9.43276 8.41116 9.589L10.9112 12.089C11.0683 12.2408 11.2788 12.3248 11.4973 12.3229C11.7158 12.321 11.9248 12.2334 12.0793 12.0789C12.2338 11.9243 12.3215 11.7153 12.3234 11.4968C12.3253 11.2783 12.2413 11.0678 12.0895 10.9107L9.83366 8.65484V4.83317C9.83366 4.61216 9.74586 4.4002 9.58958 4.24392C9.4333 4.08763 9.22134 3.99984 9.00033 3.99984Z",
    fill: "#F06E63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.ee4d1cc4bbb39a7d34a5754d1e165255.svg";
export { ForwardRef as ReactComponent };